import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { isTlfItemIndexReadDto } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { useContext, useEffect, useState, useTransition } from "react";
import { HourglassSplit, Star, Trash } from "react-bootstrap-icons";
import { eLinkType, eReleaseStatus } from "../../../functions/api/enums";
import { TlfItemTableContext } from "./TlfItemTable";

/**
 * Table cell renderer that displays status flags and action icons for TLF items.
 *
 * @param props - The component props
 * @param props.rowData - Row data containing TLF item information
 */
export const TlfItemTableFlags = ({ rowData }: ISimpleTableCellRenderProps): React.ReactElement => {
  const tlfItemTableContext = useContext(TlfItemTableContext);
  const [, startTransition] = useTransition();
  const thisRowData = isTlfItemIndexReadDto(rowData) ? rowData : null;
  const [renderTime, setRenderTime] = useState<number>(0);

  useEffect(() => {
    // Set current time after mount to avoid calling an impure function during render.
    // Added as useEffect to statisfy React v19's rules of hooks.
    startTransition(() => setRenderTime(Date.now()));
  }, []);

  return !thisRowData ? (
    <></>
  ) : (
    <div
      style={{ width: "100%" }}
      className="d-flex justify-content-center"
    >
      {thisRowData.releaseStatus === eReleaseStatus.Valid &&
        thisRowData.releaseDate &&
        new Date(thisRowData.releaseDate).getTime() >= renderTime - 28 * 86400 * 1000 &&
        ((
          <Star
            title="New"
            aria-label="New item"
          />
        ) as React.ReactElement)}
      {[eReleaseStatus.Valid, eReleaseStatus.DecommissingPending].includes(
        thisRowData.releaseStatus,
      ) &&
        thisRowData.relationships.filter((r) => r.linkType === eLinkType.Successor).length > 0 && (
          <HourglassSplit
            title="New draft exists"
            aria-label="New draft exists"
          />
        )}
      {tlfItemTableContext.canDelete &&
        tlfItemTableContext.deleteClick &&
        [eReleaseStatus.Draft, eReleaseStatus.ReleasePending].includes(
          thisRowData.releaseStatus,
        ) && (
          <Trash
            title="Delete"
            aria-label="Delete item"
            color="var(--bs-danger)"
            onClick={() =>
              tlfItemTableContext.deleteClick &&
              tlfItemTableContext.deleteClick(
                rowData.id as string,
                rowData.azsolId as string,
                rowData.version as number,
              )
            }
          />
        )}
    </div>
  );
};

TlfItemTableFlags.displayName = "TlfItemTableFlags";
